import { Flex, Text } from "@chakra-ui/react";
import { VerticalSquiggleSmallIcon } from "../../../../components/icons/VerticalSquiggleSmallIcon";

interface SectionHeaderProps {
  title: string;
  viewAllLabel?: string;
  onViewAll?: () => void;
}

export function SectionHeader({
  title,
  viewAllLabel,
  onViewAll,
}: SectionHeaderProps) {
  return (
    <Flex align="center" justify="space-between">
      <Flex align="center" gap="12px">
        <VerticalSquiggleSmallIcon color="blaze.blaze" height="24px" flexShrink={0} />
        <Text
          fontSize="20px"
          fontWeight="700"
          color="dune.dune"
          fontFamily="Bricolage Grotesque"
          lineHeight="24px"
        >
          {title}
        </Text>
      </Flex>
      {viewAllLabel && onViewAll && (
        <Flex align="center" gap={1} cursor="pointer" onClick={onViewAll} flexShrink={0}>
          <Text
            fontSize="14px"
            fontWeight="500"
            fontFamily="Roboto"
            color="dune.700"
            letterSpacing="0.5px"
            _hover={{ textDecoration: "underline" }}
          >
            {viewAllLabel}
          </Text>
        </Flex>
      )}
    </Flex>
  );
}
